<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Installation Program</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="">
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                <p>The Installation Ceremony at GHRSTU, Nagpur and GHRCACS, Nagpur symbolised fresh responsibilities, shared vision, and a commitment to collective growth.</p>
            </div>
             <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-2.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-2.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-3.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-3.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-4.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-4.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-5.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-5.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-6.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-6.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-7.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-7.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
            </div>
            
            <div class="text-justify mt-5">
                    <p>GHRCACS, Nagpur, conducted the installation program of the Engfinity Club for the new batch, marking a fresh start for incoming students. Exciting opportunities for collaboration and innovation await as they embark on their journey. </p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-2.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-2.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-3.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-3.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-4.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-4.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-5.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-5.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-6.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-6.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-7.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-7.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>